import React from "react"

const AccordionButton = (props) => (
  <button
    className="accordion-button button is-radiusless is-fullwidth py-2 px-3 mb-3 is-justify-content-space-between"
    onClick={props.onClick}
  >
    <div className="has-text-weight-bold is-size-5">{props.title}</div>
    {props.isHidden
      ? <small>&#x25C0;</small>
      : <small>&#x25BC;</small>
    }
    {props.children}
  </button>
)

export default AccordionButton
